import { colorThemeGenerator } from '@spotify-internal/encore-creator-web';

export const WRAPPED_BUTTON_COLOR_DEFAULT = 'aquamarine';
export const WRAPPED_BUTTON_COLOR_ACTIVE = '#ff3f9e';

export function getWrappedMicrositeUrl(externalPodcastId: string) {
  return `https://wrappedforpodcasters.byspotify.com/?id=${externalPodcastId}`;
}

export function getWrappedButtonTheme() {
  return colorThemeGenerator({
    primaryColor: WRAPPED_BUTTON_COLOR_DEFAULT,
    primaryColorHover: WRAPPED_BUTTON_COLOR_ACTIVE,
  });
}
